export type GoogleOAuthConnectResponse = {
  authUrl: string;
};

export type GoogleOAuthStatusResponse = {
  connected: boolean;
  gmailAccount?: string | null;
};

export type GoogleOAuthCallbackParams = {
  state?: string;
  code?: string;
  scope?: string;
  authuser?: string;
  prompt?: string;
  iss?: string;
  error?: string;
  error_description?: string;
  success?: string;
  message?: string;
};

export type PatientQuestionnaireItem = {
  id: number;
  clinicId: number;
  doctorId: number;
  title: string;
  description: string | null;
  googleFormId: string;
  responderUri: string;
  editUri: string;
  status: string;
  createdBy: number;
  createdAt: string;
  updatedAt: string;
};

export type PatientQuestionnaireListResponse = {
  totalCount: number;
  items: PatientQuestionnaireItem[];
};

export type PatientQuestionnaireSearchParams = {
  doctorId: number;
  pageNumber: number;
  pageSize: number;
};

export type CreatePatientQuestionnairePayload = {
  title: string;
  doctorId: number;
  createdBy: number;
};

export const PATIENT_QUESTIONNAIRES_QUERY_KEY = "patientQuestionnaires";
export const GOOGLE_OAUTH_STATUS_QUERY_KEY = "googleOAuthStatus";
